import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from "app/service/authentication.service";

@Component({
  selector: 'app-admin-signout',
  templateUrl: './admin-signout.component.html',
  styleUrls: ['./admin-signout.component.css']
})
export class AdminSignoutComponent implements OnInit {

  constructor(public authenticationService: AuthenticationService) { }

  ngOnInit() {
    this.authenticationService.signoutAdmin();
  }

}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/admin/admin-signout/admin-signout.component.ts